import type {
  ConversationMessage,
  ConversationMessageJsonContent,
} from "@mirage/service-conversation/types";

export const mergeMessages = (
  existingMessages: ConversationMessage[],
  newMessages: ConversationMessage[],
) => {
  const existingMessageIdToJsonContent = new Map<
    string,
    ConversationMessageJsonContent
  >();
  existingMessages.forEach(({ id, jsonContent }) => {
    if (id !== "" && jsonContent) {
      existingMessageIdToJsonContent.set(id, jsonContent);
    }
  });

  return newMessages.map((message) => {
    const jsonContent = existingMessageIdToJsonContent.get(message.id);

    if (jsonContent) {
      return {
        ...message,
        jsonContent,
      };
    }

    return message;
  });
};
